import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store } = dependencies;
  const {
    page: { deviceType },
  } = store.getState();

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <UiKitContextProvider deviceType={deviceType} useStaticDeviceType>
      <Application config={config} logger={getLogger()} reduxStore={store} customContext={customContext} />
    </UiKitContextProvider>,
    rootElement,
  );
}
